import { render, staticRenderFns } from "./c-brand-page.vue?vue&type=template&id=505f95a6&scoped=true&"
import script from "./c-brand-page.vue?vue&type=script&lang=js&"
export * from "./c-brand-page.vue?vue&type=script&lang=js&"
import style0 from "./c-brand-page.vue?vue&type=style&index=0&id=505f95a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f95a6",
  null
  
)

export default component.exports